module.exports = __webpack_public_path__ + "media/assets/images/zidosya_first_view_botton-c3097c72b3270108d9a42acd6b446838.png";